exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-rewards-card {\n  padding: 0 10px;\n}\n.preview-rewards-card .content {\n  display: flex;\n  justify-content: space-between;\n  padding: 15px 15px;\n  border-bottom: 1px solid #ccc;\n  margin: 15px 0;\n}\n.preview-rewards-card .content .first-item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n", ""]);

// exports
